import UkrailCards from './ukrail-cards-component';
import UkrailCardsService from './ukrail-cards-service';

import './ukrail-cards.scss';

const MODULE_NAME = 'app.common.widgets.ukrail-cards';
const module = angular.module(MODULE_NAME, [])
    .directive(UkrailCards.DIRECTIVE_NAME, UkrailCards)
    .service('ukrailCardsService', UkrailCardsService);

export {module, MODULE_NAME as default};



// WEBPACK FOOTER //
// ./src/app/modules/common/widgets/ukrail-cards/ukrail-cards-module.js